import { motion } from 'motion/react';
import { site } from '../data/site';
import { useScroll } from '../hooks/useScrollContext';
import useScrollSpy from '../hooks/useScrollSpy';
import { usePrefersReducedMotion } from '../effects/motionConfig';

export default function TopNav() {
  const sectionIds = ['hero', ...site.nav.map((n) => n.id)];
  const activeId = useScrollSpy(sectionIds, 120);
  const { scrollToSection, scrollY } = useScroll();
  const reduced = usePrefersReducedMotion();
  const scrolled = scrollY > 24;

  const navLinks = site.nav.map(({ id, label }) => {
    const isActive = activeId === id;
    return (
      <button
        key={id}
        type="button"
        className={`top-nav__link ${isActive ? 'top-nav__link--active' : ''}`}
        onClick={() => scrollToSection(id)}
        aria-current={isActive ? 'true' : undefined}
      >
        {label}
        {isActive && !reduced && (
          <motion.span
            className="top-nav__indicator"
            layoutId="nav-underline"
            transition={{ type: 'spring', stiffness: 380, damping: 30 }}
          />
        )}
      </button>
    );
  });

  const mobileItems = site.nav.map(({ id, label }) => {
    const isActive = activeId === id;
    return (
      <button
        key={id}
        type="button"
        className={`mobile-nav__item ${isActive ? 'mobile-nav__item--active' : ''}`}
        onClick={() => scrollToSection(id)}
        aria-current={isActive ? 'true' : undefined}
      >
        {isActive && !reduced && (
          <motion.span
            className="mobile-nav__indicator"
            layoutId="mobile-indicator"
            transition={{ type: 'spring', stiffness: 400, damping: 32 }}
          />
        )}
        {label}
      </button>
    );
  });

  if (reduced) {
    return (
      <>
        <header className={`top-nav ${scrolled ? 'top-nav--scrolled' : ''}`}>
          <div className="container top-nav__inner">
            <button type="button" className="top-nav__brand" onClick={() => scrollToSection('hero')} aria-label="Home">
              <img src={site.logo} alt="" />
              <span className="top-nav__wordmark">{site.name}</span>
            </button>
            <nav className="top-nav__links" aria-label="Sections">{navLinks}</nav>
          </div>
        </header>
        <nav className="mobile-nav" aria-label="Section navigation">{mobileItems}</nav>
      </>
    );
  }

  return (
    <>
      <motion.header
        className="top-nav"
        initial={false}
        animate={{
          backgroundColor: scrolled ? 'rgba(12, 12, 11, 0.94)' : 'rgba(12, 12, 11, 0)',
          borderBottomColor: scrolled ? 'rgba(255, 255, 255, 0.07)' : 'rgba(255, 255, 255, 0)',
        }}
        transition={{ duration: 0.3 }}
        style={{ backdropFilter: scrolled ? 'blur(12px)' : 'none' }}
      >
        <div className="container top-nav__inner">
          <motion.button
            type="button"
            className="top-nav__brand"
            onClick={() => scrollToSection('hero')}
            aria-label="Home"
            whileHover={{ opacity: 0.85 }}
            whileTap={{ scale: 0.98 }}
          >
            <img src={site.logo} alt="" />
            <span className="top-nav__wordmark">{site.name}</span>
          </motion.button>
          <nav className="top-nav__links" aria-label="Sections">{navLinks}</nav>
        </div>
      </motion.header>
      <nav className="mobile-nav" aria-label="Section navigation">{mobileItems}</nav>
    </>
  );
}
